<nb-progress-bar
  [value]="percentLeft"
  size="tiny"
  [status]="credits.enabled ? (isLowCreditsValue ? 'danger' : 'success') : 'basic'"
  >{{ shouldShowLabel ? (credits.value | gigaPixels) : '' }}
</nb-progress-bar>
